module.exports = __webpack_public_path__ + "img/background055.4d7407bb.jpg";